import { useEffect, useState } from 'react';
import {
    FaSearch, FaCheckCircle, FaRegTimesCircle,
    FaCloudDownloadAlt, FaInfoCircle
} from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';
import { BsFillSendFill } from "react-icons/bs";
import LoadingComponent from './../../widgets/LoadingComponent';
import Button from 'react-bootstrap/Button';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { getData, getFileData } from '../../api/ApiRest';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import { Breadcrumb, Modal } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { useSelector } from 'react-redux';


function NominaEnvio() {
    const [loading, setLoading] = useState(false)
    const [dataBuscar, setDataBuscar] = useState({
        Prefijo: '',
        Numero: '',
        ClienteNit: '',
        EmisorId: '',
        TipoDocumentoid: 'null',
        EstadoDocumento: '-9',
        Desde: moment(new Date(new Date(new Date().setHours(1)).setMinutes(0, 0))).format("yyyy-MM-DDTHH:mm"),
        Hasta: moment(new Date(new Date(new Date().setHours(23)).setMinutes(59, 0))).format("yyyy-MM-DDTHH:mm"),
    });
    const [documents, setDocuments] = useState([]);
    const [adminTae, SetAdminTae] = useState(false);
    const [modalReEnvio, setModalReEnvio] = useState({
        ModalVisible: false, Prefix: '', Number_: '', CorreoDestino: '', Id: ''
    });
    const [modalInfoEmision, setModalInfoEmision] = useState(false);
    const [documentSelect, setDocumentSelect] = useState({});

    const infoUser = useSelector((state) => state.auth);


    useEffect(() => {
        SetAdminTae(infoUser.AdminTae === 'true');
    }, [])



    const buscarDocumentos = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Cliente/Nomina/DocumentsPayRollGet', {
            Prefijo: dataBuscar.Prefijo,
            Number: dataBuscar.Numero,
            CompanyId_Emisior: dataBuscar.EmisorId,
            ClienteNit: dataBuscar.ClienteNit,
            FechaDesde: dataBuscar.Desde,
            FechaHasta: dataBuscar.Hasta,
            TipoDocumentoId: dataBuscar.TipoDocumentoid,
            EstadoDocumento: dataBuscar.EstadoDocumento
        }, true).then(response => {
            console.log(response);
            if (response.status === true) {
                setDocuments(response.documents);
            }
            // setDocuments(response.documents);
            setLoading(false)
        }, error => {
            alert('algo salio mal con la busqueda');
            console.log(error);
            setLoading(false)
        })

    }


    const descargarArhivo = (Id = 0, Documento = '', Tipo = 'PDF') => {

        if (Tipo === 'PDF') {
            setLoading(true);
            getFileData('api/Cliente/Nomina/NominaGetFile', { id: Id, Type: Tipo }).then(response => {
                console.log(response);
                const file = window.URL.createObjectURL(response);

                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = file;
                a.download = Documento + '.pdf';
                a.click();
                window.URL.revokeObjectURL(file);

                a.remove();

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo mal al descargar');
            });
        }
        else {
            alert('Error de extension');
        }
    }


    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                console.log(response);
                return response.companies;
            }, error => {
                return [];
            })
    }

    const enviarCorreo = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Cliente/Nomina/SendNomina', {
            id: modalReEnvio.Id,
            correo: modalReEnvio.CorreoDestino
        }).then(response => {
            alert('Enviado con éxito');
            setModalReEnvio({
                ModalVisible: false,
                CorreoDestino: '',
                Id: '',
                Number_: '',
                Prefix: ''
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }


    return (
        <div className="BodyComponent">
            <Breadcrumb>
                <Breadcrumb.Item style={{ fontSize: 14 }} >Empresas</Breadcrumb.Item>
                <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Nomina Envios</Breadcrumb.Item>
            </Breadcrumb>

            <Form onSubmit={buscarDocumentos}>

                <div className='row'>

                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="EmisionDesde"
                            label="Emision Desde"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="datetime-local"
                                autoComplete='off'
                                required={true}
                                placeholder="Emision Desde"
                                value={dataBuscar.Desde}
                                onChange={value => {
                                    // console.log(value.target.value)
                                    setDataBuscar({
                                        ...dataBuscar,
                                        Desde: value.target.value
                                    })
                                }}
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="EmisionHasta"
                            label="Emision Hasta"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="datetime-local"
                                autoComplete='off'
                                required={true}
                                placeholder="Emision Hasta"
                                value={dataBuscar.Hasta}
                                onChange={value => {
                                    setDataBuscar({ ...dataBuscar, Hasta: value.target.value })
                                }}
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-6'>
                        <FloatingLabel
                            controlId="TipoDocumento"
                            label="Tipo Documento"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={dataBuscar.TipoDocumentoid}
                                onChange={event => {
                                    setDataBuscar({
                                        ...dataBuscar,
                                        TipoDocumentoid: event.target.value
                                    })
                                }}
                                className="input-fecha-sm"
                            >
                                <option value="null">TODOS</option>
                                <option value="9">Nomina Individual</option>
                                <option value="10">Nomina Individual de Ajuste</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>


                    <div className='col-md-2'>
                        <FloatingLabel
                            controlId="EstadoDocumento"
                            label="Estado Documento"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={dataBuscar.EstadoDocumento}
                                onChange={event => {
                                    setDataBuscar({
                                        ...dataBuscar,
                                        EstadoDocumento: event.target.value
                                    })
                                }}
                                className="input-fecha-sm"
                            >
                                <option value="-9">Todos</option>
                                <option value="1">Aceptado</option>
                                <option value="0">Rechazado</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>

                    <div className='col-md-2'>
                        <FloatingLabel
                            controlId="Prefijo"
                            label="Prefijo"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="text"
                                autoComplete='off'
                                placeholder="Prefijo"
                                value={dataBuscar.Prefijo}
                                onChange={value => setDataBuscar({ ...dataBuscar, Prefijo: value.target.value })}
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-2'>
                        <FloatingLabel
                            controlId="Consecutivo"
                            label="Consecutivo"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="number"
                                autoComplete='off'
                                placeholder="Consecutivo"
                                value={dataBuscar.Numero}
                                onChange={value => setDataBuscar({ ...dataBuscar, Numero: value.target.value })}
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="ClienteNit"
                            label="Empleado Identificación"
                            className="form-floating-sm mb-3"
                        >
                            <Form.Control
                                size='sm'
                                type="number"
                                autoComplete='off'
                                placeholder="Cliente Identificación"
                                value={dataBuscar.ClienteNit}
                                onChange={value => setDataBuscar({ ...dataBuscar, ClienteNit: value.target.value })}
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>

                    {adminTae === true ?
                        <>
                            <div className='col-md-5'>
                                <label>Empresa Emisora</label>
                                <AsyncSelect cacheOptions defaultOptions
                                    menuPosition='fixed'
                                    noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                                    placeholder="Empresa Emisora"
                                    isClearable={true}
                                    loadOptions={companieSearchSelect2}
                                    onChange={value => {

                                        if (value === null)
                                            setDataBuscar({ ...dataBuscar, EmisorId: null })
                                        else
                                            setDataBuscar({ ...dataBuscar, EmisorId: value.value })
                                    }}
                                />

                            </div>

                        </>
                        :
                        null
                    }





                    <div className='col-md-1'>
                        <Button variant='primary' type='submit' size='sm'>
                            <FaSearch size={'0.8rem'} />
                        </Button>
                    </div>

                </div>

            </Form>

            {<LoadingComponent Loading={loading} />}


            <div className='table-responsive mt-3'>
                <table className='table table-bordered  table-hover'>
                    <thead>
                        <tr className='table-info'>
                            {adminTae === true ?
                                <th>
                                    Emisor Nit
                                </th>
                                : null}
                            <th>
                                Tipo Documento
                            </th>
                            <th>
                                Documento
                            </th>
                            <th>
                                Fecha Emisión
                            </th>
                            <th>
                                Empleado
                            </th>
                            <th>
                                Ingresos
                            </th>
                            <th>
                                Deducción
                            </th>
                            <th>
                                Total
                            </th>
                            <th>
                                Estado Documento
                            </th>
                            <th>
                                Accion
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {documents.map((item, key) => (
                            <tr key={key}>
                                {adminTae === true ?
                                    <td className='text-center'>
                                        {item.emisor_Nit}
                                    </td>
                                    : null}
                                <td>
                                    {item.typeDocument}
                                </td>
                                <td className='text-center'>
                                    {item.typeDocument_Prefix + ' - ' + item.consecutive}
                                </td>
                                <td className='text-center'>
                                    {moment(item.dateTime_Emision).format('D-MM-yyyy / hh:mm:ss a')}
                                </td>
                                <td className='text-center'>
                                    {item.client_Nit}
                                </td>
                                <td className='text-center'>
                                    <NumericFormat displayType='text'
                                        thousandSeparator=','
                                        value={item.ingresos} />
                                </td>
                                <td className='text-center'>
                                    <NumericFormat displayType='text'
                                        thousandSeparator=','
                                        value={item.deducciones} />
                                </td>
                                <td className='text-center'>
                                    <NumericFormat displayType='text'
                                        thousandSeparator=','
                                        value={item.total} />
                                </td>
                                <td className='text-center'>
                                    {item.stateDocument === 1 ?
                                        <FaCheckCircle size={'1rem'} color='green' />
                                        :
                                        <FaRegTimesCircle size={'1rem'} color='red' />
                                    }
                                </td>
                                <td className='text-center'>
                                    <div style={{ display: 'flex' }}>
                                        <Dropdown>
                                            <Dropdown.Toggle size='sm' variant="dark" id="dropdown-basic" title='Descargar'>
                                                <FaCloudDownloadAlt size={'1rem'} />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => descargarArhivo(item.documentId,
                                                        item.typeDocument_Prefix + ' - ' + item.consecutive,
                                                        'PDF')}
                                                >PDF</Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => descargarArhivo(item.documentId,
                                                        item.typeDocument_Prefix + ' - ' + item.consecutive,
                                                        'XML')}
                                                >XML</Dropdown.Item>
                                                <Dropdown.Item href="#/action-3">ZIP</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <button type='button'
                                            onClick={() => {
                                                setModalReEnvio({
                                                    ModalVisible: true,
                                                    Prefix: item.typeDocument_Prefix,
                                                    Number_: item.consecutive,
                                                    Id: item.documentId
                                                });
                                                setDocumentSelect(item);
                                            }}
                                            title='Re enviar documento'
                                            className='btn btn-sm btn-primary mx-1'>
                                            <BsFillSendFill size={'1rem'} />
                                        </button>

                                        <button type='button'
                                            onClick={() => {
                                                setModalInfoEmision(true);
                                                setDocumentSelect(item);
                                            }}
                                            title='Ver informacion de emision'
                                            className='btn btn-sm btn-secondary mx-1'>
                                            <FaInfoCircle size={'1rem'} />
                                        </button>

                                    </div>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Modal
                size='xl'
                show={modalReEnvio.ModalVisible}
                onHide={() => {
                    setModalReEnvio(
                        {
                            ModalVisible: false,
                            CorreoDestino: '',
                            Prefix: '',
                            Number_: '',
                            Id: ''
                        }
                    )
                }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Re Envio de documento
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {<LoadingComponent Loading={loading} />}
                    <Form onSubmit={enviarCorreo}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId="DocumentRef"
                                    label="Documento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        autoComplete='off'
                                        value={modalReEnvio.Prefix + '-' + modalReEnvio.Number_}
                                        readOnly={true}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-6'>
                                <FloatingLabel
                                    controlId="Email"
                                    label="Email"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        size='sm'
                                        required={true}
                                        type='email'
                                        autoComplete='off'
                                        value={modalReEnvio.CorreoDestino}
                                        onChange={e => setModalReEnvio({ ...modalReEnvio, CorreoDestino: e.target.value })}
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-2'>
                                <button type='submit' className='btn btn-primary'>
                                    Enviar
                                </button>
                            </div>

                        </div>
                    </Form>


                </Modal.Body>
            </Modal>

        </div>
    );
}

export default NominaEnvio;
